<template>
  <div class="box">
    <div class="left-box">
      <div class="head-box">
        <h4>个人资料</h4>
      </div>
      <div class="left-content c-p-10">
        <el-upload
          class="avatar-uploader"
          style="margin: 10px auto 20px;"
          action
          :show-file-list="false"
          :auto-upload="false"
          :on-change="getFileToBase64"
        >
          <img v-if="profile.avatar && profile.avatar.length > 50" :src="profile.avatar" />
          <img v-else src="../assets/user.png" />
        </el-upload>
        <el-form
          :model="profile"
          :rules="rules"
          ref="profile"
          label-width="70px"
          label-position="left"
          hide-required-asterisk
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="profile.name" suffix-icon="el-icon-user"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="profile.phone" suffix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="profile.email" suffix-icon="el-icon-message"></el-input>
          </el-form-item>
          <el-form-item
            label="地址"
            prop="address"
            v-if="this.entity.accountType == 'c' || this.entity.accountType == 'a'"
          >
            <el-input v-model="profile.address" suffix-icon="el-icon-map-location"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="profileSave" type="primary">确定</el-button>
            <el-button @click="getUserInfo">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="right-box"></div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'preferences',
  data() {
    return {
      profile: {}, //个人资料表单
      rules: this.$util.rules,
      activeName: 'first',
      formData: {} //修改密码表单
    };
  },
  //引用父页面方法
  inject: ['logout', 'getProfile'],
  created() {
    this.entity = JSON.parse(sessionStorage['entity']);
  },
  mounted() {
    window.$this = this;
    //租户管理员与员工查询接口不同
    if (this.entity.accountType == 'c' || this.entity.accountType == 'a') {
      this.getProfileInfo();
    } else {
      this.getUserInfo();
    }
  },
  methods: {
    doInit() {
      this.formData = {};
      if (this.$refs.formData) this.$refs.formData.resetFields();
    },
    //查询user个人信息
    getUserInfo() {
      this.osg.ajax(`user/find/${this.entity.entityID}.do`, {}, res => {
        this.profile = res.entity || {};
      });
    },
    //获取当前租户信息
    getProfileInfo() {
      this.osg.ajax(`tenant/find/${this.entity.entityID}.do`, {}, res => {
        this.profile = res.entity || {};
      });
    },
    //上传头像图片文件转base64
    getFileToBase64(file) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式!', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB!', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.profile.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    //修改个人资料
    profileSave() {
      let url = '';
      if (this.entity.accountType == 'c' || this.entity.accountType == 'a') {
        url = 'tenant/upsert.do';
      } else {
        url = 'user/updateUserInfo.do';
      }
      if (this.osg.validate('profile')) {
        this.osg.ajax(
          url,
          this.profile,
          () => {
            this.osg.toast('个人资料保存成功！');
            this.getProfile();
            if (this.entity.accountType == 'c' || this.entity.accountType == 'a') {
              this.getProfileInfo();
            } else {
              this.getUserInfo();
            }
          },
          err => {
            console.log(err);
          }
        );
      }
    }
  }
};
</script>
